import update from 'immutability-helper';

import { ActionType, defaultAction } from '../types';
import { ACTION_TYPES } from '../types/productStatusTypes';

type ProductStatusData = {
  product: string;
  status: string;
};

type ProductStatusState = {
  data: ProductStatusData[];
  isFetching: boolean;
};

const initialState: ProductStatusState = {
  data: [],
  isFetching: false,
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;

  switch (type) {
    case ACTION_TYPES.LOAD_PRODUCT_STATUS_LIST:
      return update(state, {
        isFetching: {
          $set: true,
        },
      });
    case ACTION_TYPES.LOAD_PRODUCT_STATUS_LIST_SUCCESS:
      return update(state, {
        data: {
          $set: payload.data,
        },
        isFetching: {
          $set: false,
        },
      });

    case ACTION_TYPES.LOAD_PRODUCT_STATUS_LIST_FAILED:
      return update(state, {
        isFetching: {
          $set: false,
        },
      });
    default:
      return state;
  }
};
